import { useLiteSiteStore } from "../store";

export function scrollBookingIntoView(dateString: string | undefined) {
  useLiteSiteStore.setState(() => ({
    scrollBookingIntoView: dateString,
  }));
}
